import { forwardRef, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';

const toastStyle = {
  position: 'fixed', bottom: '4rem', left: '50%', transform: 'translateX(-50%)', zIndex: 2000,
  color: '#fff', borderRadius: '8px',
  padding: '0.6em 1em', fontFamily: 'Verdana', fontSize: '0.82em',
  boxShadow: '0 4px 16px rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', gap: '0.75em',
};

const ToastContainer = forwardRef(function ToastContainer({ t }, ref) {
  const [zbError, setZbError] = useState('');
  const [zbSuccess, setZbSuccess] = useState(false);
  const [zbUnknownDevice, setZbUnknownDevice] = useState(false);
  const [zbDevicePaired, setZbDevicePaired] = useState(false);
  const [zbPjRemaining, setZbPjRemaining] = useState(0);
  const [sessionStarted, setSessionStarted] = useState(false);

  useImperativeHandle(ref, () => ({
    showZbError: (msg) => setZbError(msg),
    clearZbError: () => setZbError(''),
    showZbSuccess: () => {
      setZbSuccess(true);
      setTimeout(() => setZbSuccess(false), 3000);
    },
    showZbUnknownDevice: () => setZbUnknownDevice(true),
    hideZbUnknownDevice: () => setZbUnknownDevice(false),
    updateZbPjRemaining: (remaining) => setZbPjRemaining(remaining),
    showZbDevicePaired: () => {
      setZbDevicePaired(true);
      setTimeout(() => setZbDevicePaired(false), 4000);
    },
    showSessionStarted: () => {
      setSessionStarted(true);
      setTimeout(() => setSessionStarted(false), 1000);
    },
  }));

  return createPortal(
    <>
      {zbError && (
        <div style={{ ...toastStyle, background: '#cc4444', maxWidth: '320px' }}>
          <span>{zbError}</span>
          <span onClick={() => setZbError('')} style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', lineHeight: 1 }}>✕</span>
        </div>
      )}
      {zbSuccess && (
        <div style={{ ...toastStyle, background: '#00aa55', maxWidth: '320px' }}>
          <span>{t('zigbeeConnected')}</span>
        </div>
      )}
      {zbUnknownDevice && (
        <div style={{ ...toastStyle, background: '#e67e00', maxWidth: '360px' }}>
          <span>
            {t('zigbeeDeviceNotPaired')}{zbPjRemaining > 0 && <strong> ⏱ {zbPjRemaining}s</strong>}
          </span>
          <span onClick={() => setZbUnknownDevice(false)} style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', lineHeight: 1 }}>✕</span>
        </div>
      )}
      {zbDevicePaired && (
        <div style={{ ...toastStyle, background: '#00aa55', maxWidth: '360px' }}>
          <span>{t('zigbeeDevicePaired')}</span>
        </div>
      )}
      {sessionStarted && (
        <div style={{ ...toastStyle, background: '#1a6fcc', maxWidth: '360px' }}>
          <span>{t('sessionStarted')}</span>
        </div>
      )}
    </>,
    document.body
  );
});

export default ToastContainer;
